import { createAction, props } from '@ngrx/store';

export const loadIfaPutAddProducts = createAction(
  '[IfaPutAddProduct] Load IfaPutAddProducts',
  props<{ businessId: string; employeeId: string; productId: string; businessProductSolutionIdList: string[] }>()
);

export const loadIfaPutAddProductsSuccess = createAction(
  '[IfaPutAddProduct] Load IfaPutAddProducts Success',
  props<{ response: string }>()
);

export const loadIfaPutAddProductsFailure = createAction(
  '[IfaPutAddProduct] Load IfaPutAddProducts Failure',
  props<{ error: Error | any }>()
);
